(function () {
	const testiSwiperEl = document.querySelectorAll('.testi-swiper');
	if (typeof Swiper !== 'undefined' && testiSwiperEl.length !== 0) {
		new Swiper('.testi-swiper', {
			pagination: {
				el: '.cta-testi-dots',
				clickable: true,
			},
			navigation: {
				nextEl: '.cta-testi-next',
				prevEl: '.cta-testi-prev',
			},
		});
	}

	const root = document.querySelector('.tb');
	if (!root || typeof Swiper === 'undefined') {
		return;
	}

	const swiperEl = root.querySelector('.tb-swiper');
	if (!swiperEl) {
		return;
	}

	new Swiper(swiperEl, {
		effect: 'cards',
		grabCursor: true,
		loop: true,
		speed: 550,
		cardsEffect: {
			perSlideOffset: 6,
			perSlideRotate: 4,
			rotate: true,
			slideShadows: false,
		},
		navigation: {
			nextEl: root.querySelector('.tb-next'),
			prevEl: root.querySelector('.tb-prev'),
		},
		pagination: {
			el: root.querySelector('.tb-dots'),
			clickable: true,
		},
	});
})();
